import React, { Component } from 'react'
import Auth from '../../Modules/Auth'
import axios from 'axios'
import { withCookies, Cookies } from 'react-cookie'
import './NoticePage.scss'
import NoticeItem from '../../Components/Notice/NoticeItem'
import HeaderMenu from '../../Components/Commons/HeaderMenu'

class NoticePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            list: null,
            dayList: [],
            isReadNO: [],
            deletePop: false,
            user: null,
        }
    }
    UNSAFE_componentWillMount() {
        this.loadUser()
    }

    loadUser = () => {
        axios
            .get(`${BACKEND_HOST}/auth/me`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.setState({ user: res.data })

                this.loadList()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadList = () => {
        const { cookies } = this.props

        axios
            .get(`${BACKEND_HOST}/logs/?project_id=${cookies.get('project')}&limit=200`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                const newdayList = []
                const newIsReadNo = []
                const list = res.data.data.filter((item) => {
                    if (['POSTING_COMMENT', 'REPORT_COMMENT'].includes(item.logType)) {
                        if (item.landing.accessLevel === 'PROJECT') return true
                        return false
                    }

                    if (item.logType === 'RFI_COMMENT') {
                        if (item.landing.assignee_id === this.state.user._id || item.user_id === this.state.user._id) {
                            return true
                        }
                        return false
                    }

                    return true
                })

                for (let i = 0; i < list.length; i += 1) {
                    const menu = list[i].landing.menu
                    const type = list[i].landing.type

                    if (
                        menu === 'RFI' ||
                        menu === 'REPORT' ||
                        menu === 'POSTING' ||
                        menu === 'RFI_COMMENT' ||
                        menu === 'RFI_RESPONSE' ||
                        menu === 'REPORT_COMMENT' ||
                        menu === 'POSTING_COMMENT'
                    ) {
                        if (menu === 'RFI') {
                            if (list[i].user_id === this.state.user._id) {
                                // 건축주 요청
                            } else if (list[i].landing.assignee_id === this.state.user._id) {
                                // 건축주 할일
                            } else {
                                continue
                            }
                        }

                        const newDate = new Date(list[i].createdAt)
                        const newYear = newDate.getFullYear()
                        const newMonth = newDate.getMonth() + 1
                        const newDay = newDate.getDate()
                        const week = new Array('일', '월', '화', '수', '목', '금', '토')
                        const newDayName = week[newDate.getDay()]
                        const day = newYear + '년 ' + newMonth + '월 ' + newDay + '일 ' + '(' + newDayName + ')'

                        list[i]['day'] = day

                        if (!newdayList.includes(day)) {
                            newdayList.push(day)
                        }

                        if (list[i].isRead === false) {
                            newIsReadNo.push(list[i]._id)
                        }
                    }
                }

                this.setState({
                    dayList: newdayList,
                    isReadNO: newIsReadNo,
                    list,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clickLink = (item) => {
        let landingUrl = '/'
        const menu = item.landing.menu
        const type = item.landing.type
        if (menu === 'REPORT' || menu === 'REPORT_COMMENT') {
            landingUrl = `/report/${item.landing._id}/`
        } else if (menu === 'POSTING' || menu === 'POSTING_COMMENT') {
            if (type === 'MEETING') {
                landingUrl = `/meeting/${item.landing._id}/`
            }
        } else if (menu === 'RFI' || menu === 'RFI_COMMENT' || menu === 'RFI_RESPONSE') {
            if (item.user_id === this.state.user._id) {
                // 건축주 요청
                landingUrl = `/demand/${item.landing._id}/`
            } else if (item.landing.assignee_id === this.state.user._id) {
                // 건축주 할일
                landingUrl = `/todo/${item.landing._id}/`
            }
            // TODO : writer, assignee 보고 분기 처리
            // if (type === 'CLIENT_TODO') {
            //     landingUrl = `/todo/${item.landing._id}/`
            // } else if (type === 'CLIENT_REQUEST') {
            //     landingUrl = `/demand/${item.landing._id}/`
            // }
        }
        this.props.history.push(landingUrl)
    }

    deleteNotice = (id) => {
        axios
            .delete(`${BACKEND_HOST}/logs/${id}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res)
                this.loadList()
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteAllNotice = () => {
        const { cookies } = this.props
        axios
            .delete(`${BACKEND_HOST}/logs/?project_id=${cookies.get('project')}`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                console.log(res)
                this.setState({
                    list: [],
                    dayList: [],
                    isReadNO: [],
                    deletePop: false,
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderNotice = () => {
        const List = this.state.dayList.map((dayList, i) => {
            return (
                <NoticeItem
                    dayList={dayList}
                    list={this.state.list}
                    key={i}
                    clickLink={this.clickLink}
                    deleteNotice={this.deleteNotice}
                    userGroup={this.state.userGroup}
                />
            )
        })
        return List
    }

    render() {
        if (this.state.list) {
            return (
                <div>
                    <HeaderMenu />
                    <div className="section_wrap">
                        <div className="notice_page_wrap common_list">
                            <div className="common_wrap">
                                {this.state.list.length !== 0 && (
                                    <div
                                        className="green_btn_s pc_v"
                                        onClick={() => this.setState({ deletePop: true })}>
                                        모두삭제
                                    </div>
                                )}
                                {this.state.list.length !== 0 && (
                                    <div
                                        className="full_btn_m mobile_v"
                                        onClick={() => this.setState({ deletePop: true })}>
                                        모두삭제
                                    </div>
                                )}
                                {this.state.deletePop && (
                                    <div className="alret_pop2_bg">
                                        <div className="alret_pop2_wrap">
                                            <p className="h1_text">삭제하시겠습니까?</p>
                                            <p>삭제하면 복원할 수 없습니다.</p>
                                            <div
                                                className="btn btn1"
                                                onClick={() => this.setState({ deletePop: false })}>
                                                아니오
                                            </div>
                                            <div className="btn btn2" onClick={() => this.deleteAllNotice()}>
                                                네
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <h1>알림</h1>
                                {this.state.list.length !== 0 && (
                                    <div className="no_read_num">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12"
                                            height="14"
                                            viewBox="0 0 12 14">
                                            <g fill="none" fillRule="evenodd" stroke="#000" strokeWidth="1.1">
                                                <path d="M7.5 11.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                                <path
                                                    fill="#f6f8fb"
                                                    d="M11.052 11H.842c-.112 0-.182-.108-.126-.196.55-.865.839-1.845.839-2.842V4.968C1.555 2.777 3.52 1 5.946 1c2.426 0 4.392 1.777 4.392 3.968v2.994c0 .997.29 1.977.839 2.842.055.088-.014.196-.125.196z"
                                                />
                                                <path d="M1.455 8h8.45" />
                                            </g>
                                        </svg>
                                        <p>
                                            읽지 않은 알림 <span>{this.state.isReadNO.length}</span>개
                                        </p>
                                    </div>
                                )}
                                {this.state.list.length !== 0 ? (
                                    <div className="notice_list_wrap">{this.renderNotice()}</div>
                                ) : (
                                    <div className="notice_no">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="67"
                                            height="65"
                                            viewBox="0 0 67 65">
                                            <defs>
                                                <linearGradient id="a" x1="50%" x2="50%" y1="71.88%" y2="100%">
                                                    <stop offset="0%" stopColor="#E7E9EF" />
                                                    <stop offset="100%" stopColor="#E0E3E9" />
                                                </linearGradient>
                                                <linearGradient id="b" x1="50%" x2="50%" y1="6.959%" y2="89.869%">
                                                    <stop offset="0%" stopColor="#E7E9EF" />
                                                    <stop offset="100%" stopColor="#E2E5EB" />
                                                </linearGradient>
                                            </defs>
                                            <g fill="none" fillRule="evenodd">
                                                <path
                                                    fill="url(#a)"
                                                    d="M56.958 47a35.31 35.31 0 0 0 3.613 9 .805.805 0 0 1-.695 1.208H40.164a7.977 7.977 0 0 1-15.95 0H3.12A.805.805 0 0 1 2.424 56a35.342 35.342 0 0 0 3.614-9h50.92zm-.53-2.513H6.568c.344-1.985.52-4.003.52-6.032v-10.96C7.087 13.967 18.014 3 31.497 3 44.978 3 55.91 13.967 55.91 27.495v10.96c0 2.03.174 4.047.518 6.032z"
                                                    transform="translate(-2)"
                                                />
                                                <g
                                                    stroke="#FFF"
                                                    strokeLinecap="round"
                                                    strokeWidth="2.3"
                                                    transform="translate(36.4 1.4)">
                                                    <circle
                                                        cx="14.6"
                                                        cy="14.6"
                                                        r="14"
                                                        fill="url(#b)"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path d="M9.326 20.013L20.014 9.1M9.326 9.101l10.687 10.912" />
                                                </g>
                                            </g>
                                        </svg>
                                        <p>알림이 없습니다.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div>
                <HeaderMenu />
                <div className="section_wrap" />
            </div>
        )
    }
}

export default withCookies(NoticePage)



// WEBPACK FOOTER //
// ./Src/Containers/Notice/NoticePage.js